// extracted by mini-css-extract-plugin
export default {"loadingContainer":"index-module__loadingContainer____A_Nh","favoritesEmpty":"index-module__favoritesEmpty___RmswT","header":"index-module__header___z5k7v"};